import { ActionTypes } from '../constants/action-types';

export const setMovies = (movies) => {
    return {
        type: ActionTypes.SET_MOVIES,
        payload: movies,
    }
}

export const selectedMovie = (movie) => {
    return {
        type: ActionTypes.SELECTED_MOVIE,
        payload: movie,
    }
}

export const removeSelectedMovie = () => {
    return {
        type: ActionTypes.REMOVE_SELECTED_MOVIE,
    }
}

export const setFeaturedMovies = (featuredMovies) => {
    return {
        type: ActionTypes.SET_FEATURED_MOVIES,
        payload: featuredMovies,
    }
}

export const setMainMovies = (mainMovies) => {
    return {
        type: ActionTypes.SET_MAIN_MOVIES,
        payload: mainMovies,
    }
}

export const setHeroMovie = (heroMovieMain) => {
    return {
        type: ActionTypes.SET_HERO_MOVIE,
        payload: heroMovieMain,
    }
}

export const addToWatchlist = (watchlistMovie) => {
    return {
        type: ActionTypes.ADD_TO_WATCHLIST,
        payload: watchlistMovie,
    }
} 

export const removeFromWatchlist = (watchlistMovieRem) => {
    return {
        type: ActionTypes.REMOVE_FROM_WATCHLIST,
        payload: watchlistMovieRem,
    }
}

export const badgeTrue = (selectedBadge) => {
    return {
        type: ActionTypes.BADGE_TRUE,
        payload: selectedBadge,
    }
}